import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { baseHelper, storageHelper } from "lib/helpers";
import PublicContainer from "./publicContainer";

// import helpers

const PublicRoute = ({ children, ...rest }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const isLoadUrl = baseHelper.isLoadUrl(currentPath);

  if (storageHelper.get("token") && !isLoadUrl) {
    return <Navigate to={{ pathname: "/", state: { from: location } }} />;
  }

  return <PublicContainer {...rest}>{children}</PublicContainer>;
};

PublicRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default PublicRoute;
